const __WEBPACK_NAMESPACE_OBJECT__ = require("publishimo-webpack-plugin");